import { render, staticRenderFns } from "./sureDelete.vue?vue&type=template&id=f682167a&"
import script from "./sureDelete.vue?vue&type=script&lang=js&"
export * from "./sureDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports